import script from "./HrLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HrLayout.vue?vue&type=script&setup=true&lang=js"

import "./HrLayout.vue?vue&type=style&index=0&id=30190ac0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30190ac0"]])

export default __exports__